export default __webpack_public_path__ + "static/media/Pallone.f1d42aa7.jpg";